import type { ReactNode } from 'react';

/**
 * "Label : value" row used on detail screens. Previously duplicated verbatim
 * in `routes/users/Detail.tsx` and `routes/matches/Detail.tsx`.
 *
 * `value` accepts a ReactNode so call sites can render links, chips, or
 * `<span className="font-mono">` inline without fighting the wrapper.
 */

export interface DataRowProps {
  label: ReactNode;
  value: ReactNode;
  testId?: string;
}

export default function DataRow({ label, value, testId }: DataRowProps) {
  return (
    <div className="flex items-start justify-between text-sm gap-3">
      <span className="text-slate-500 shrink-0">{label}</span>
      <span
        className="font-medium text-slate-900 text-right break-all"
        data-testid={testId}
      >
        {value}
      </span>
    </div>
  );
}
